import { render, staticRenderFns } from "./RemoveProviderDialog.vue?vue&type=template&id=623f5f50&"
import script from "./RemoveProviderDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveProviderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports